import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: {
      profile: null
    },
    actions: {},
    mutations: {
      SET_PROFILE (state, { id, name, birthdate, sex, disability }) {
        Vue.set(state, 'profile', { id, name, birthdate, sex, disability })
      }
    },
    getters: {},
    modules: {}
  })
}
